<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('wallet.title') }}</h6>
          <p class="font13 gray-col">{{ $t('wallet.subtitle') }}</p>
        </div>
      </div>
      <div class="card-wallet">
        <div class="flex-group-me">
          <img
            class="wallet-img"
            :src="require('../assets/imgs/Group 179836.png')"
            alt=""
          />
        </div>
        <div class="text-center mb-3 gray-col">{{ $t('wallet.currentBalance') }}</div>
        <div class="text-center mb-3 num-wallet">{{ wallet }} ر.س</div>
        <div class="flex-group-me mb-3">
          <button class="main-btn up xl" @click="showSettlement = true">
            {{ $t('wallet.settlementRequest') }}
          </button>
        </div>
      </div>
    </div>
  </main>

  <!-- Settlement modal  -->
  <Dialog v-model:visible="showSettlement" modal :style="{ width: '650px' }">
    <div class="modal-body-main modal-pad-main">
      <h6 class="text-center mb-4">{{ $t('wallet.settlementAccount') }}</h6>
      <v-form @submit.prevent="settlementValid" v-model="valid" ref="form">
        <div class="main-input-cont mt-1">
          <h6 class="mb-2 font14">{{ $t('wallet.bankName') }}</h6>
          <v-text-field
            type="text"
            name="bank_name"
            :rules="defaultRoles"
            :placeholder="$t('wallet.bankNamePlaceholder')"
          ></v-text-field>
        </div>
        <div class="main-input-cont mt-1">
          <h6 class="mb-2 font14">{{ $t('wallet.accountNumber') }}</h6>
          <v-text-field
            type="text"
            name="account_number"
            :rules="defaultRoles"
            :placeholder="$t('wallet.accountNumberPlaceholder')"
          ></v-text-field>
        </div>
        <div class="main-input-cont mt-1">
          <h6 class="mb-2 font14">{{ $t('wallet.ibanNumber') }}</h6>
          <v-text-field
            type="text"
            :rules="defaultRoles"
            name="iban"
            :placeholder="$t('wallet.ibanPlaceholder')"
          ></v-text-field>
        </div>
        <div class="flex-group-me">
          <button type="submit" :disabled="disabled" class="main-btn up lg">
            <div v-if="!disabled">{{ $t('wallet.confirm') }}</div>
            <div class="loading" role="status" v-if="disabled">
              {{ $t('wallet.confirming') }}
              <div class="spinner-small-white" v-if="disabled"></div>
            </div>
          </button>
        </div>
      </v-form>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        {{ $t('wallet.settlementSuccess') }}
      </h6>
      <div class="flex-group-me mb-2">
        <router-link
          to="/walletView"
          @click="getWalletAgain"
          class="main-btn lg up"
        >
          {{ $t('wallet.wallet') }}
        </router-link>
        <router-link to="/dashboardHome" class="main-btn lg up trans">
          {{ $t('wallet.home') }}
        </router-link>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import Dialog from "primevue/dialog";
import axios from "axios";
import { useToast } from "primevue/usetoast";
const toast = useToast();
const { t } = useI18n();

// reactive state
const wallet = ref("");
const form = ref(null);
const showSettlement = ref(false);
const showSuccess = ref(false);
const disabled = ref(false);
const successImg = ref(require("../assets/imgs/check.png"));
const valid = ref(false);
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('wallet.fieldRequired');
  },
]);

// functions
function settlementValid() {
  if (valid.value) {
    settlement();
  }
}

function settlement() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  fd.append("amount", wallet.value);

  axios
    .post("/settlement-request", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showSettlement.value = false;
        showSuccess.value = true;
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

function getWallet() {
  axios
    .get("/manager/wallet", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      wallet.value = response.data.data.wallet;
    });
}
function getWalletAgain() {
  showSuccess.value = false;
  getWallet();
}
// lifecycle hooks
onMounted(() => {
  getWallet();
  // console.log(`mounted`);
});
</script>
